import moment from "moment";
import UIkit from "uikit";
import React, { useContext, useState, useEffect, useMemo } from "react";

import { AppContexts } from "../../providers";
import { Image } from "uikit-react";
import ReservationNumber from "../common/ReservationNumber";
import PropertyDetailsModal from "../common/PropertyDetailsModal";

import { host } from "../../http";

const GuestDetails = (props) => {
  const { contact = null, guest_reservations = [], guest = null } = props;
  const threadInfo =
    !guest || guest?.guest_id == "0" ? contact || {} : guest || {};
  const { user } = useContext(AppContexts.AuthContext);

  const [indexes, setIndexes] = useState({
    current: 0,
    upcoming: 0,
    past: 0,
  });
  const [currentReservation, setCurrentReservation] = useState({});
  const [propertyDetailsOpen, setPropertyDetailsOpen] = useState(false);

  const sortedReservations = useMemo(() => {
    const current = [],
      upcoming = [],
      past = [];

    const today = moment().startOf("day");
    guest_reservations.forEach((it) => {
      const checkIn = moment(it.check_in, "YYYY-MM-DD");
      const checkOut = moment(it.check_out, "YYYY-MM-DD");

      if (checkIn.isAfter(today)) {
        upcoming.push(it);
      } else if (checkOut.isBefore(today)) {
        past.push(it);

      } else {
        current.push(it);
      }
    });
    return { current, upcoming, past };
  }, [guest_reservations]);

  const incrementIndex = (tab) => {
    const length = sortedReservations[tab].length;
    setIndexes({ ...indexes, [tab]: (indexes[tab] + 1) % length });
  };

  const decrementIndex = (tab) => {
    const length = sortedReservations[tab].length;
    setIndexes({ ...indexes, [tab]: (indexes[tab] - 1 + length) % length });
  };

  const formatMoney = (n) =>
    Number(n || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const reservationRenderer = (tab) => {
    const reservation = sortedReservations[tab][indexes[tab]];
    if (!reservation) return null;

    const rentOwed = Number(reservation?.rent_owed || 0);
    const rentTotal = Number(reservation?.rent_total || 0);

    return (
      <div className="guest-chat-info-wrapper">
        {sortedReservations[tab].length > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              Booking {indexes[tab] + 1} of {sortedReservations[tab].length}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <span
                uk-icon="arrow-left"
                className="uk-icon-button"
                onClick={() => decrementIndex(tab)}
              ></span>
              <span
                uk-icon="arrow-right"
                className="uk-icon-button"
                onClick={() => incrementIndex(tab)}
              ></span>
            </div>
          </div>
        )}

        {reservation.category === "CXL" && (
          <div className="hms-booking-tag uk-margin-small-top cancelled">
            Cancelled Booking
          </div>
        )}
        <div className="uk-margin-small-top message-text-group">
          <span uk-tooltip="Check-In - Check-Out">
            <Image src="/images/check-in-check-out.svg" />
          </span>
          <div className="chat-value">
            {moment(reservation?.check_in).format("MMM DD, YYYY")} -{" "}
            {moment(reservation?.check_out).format("MMM DD, YYYY")}
          </div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Property ID">
            <Image src="/images/property-id.svg" />
          </span>
          <div className="chat-value">
            {reservation?.pms_id}
            {reservation?.rental_id && (
              <span
                className="guest-detail-more-info uk-margin-small-left"
                uk-tooltip="Property Details"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentReservation(reservation);
                  setPropertyDetailsOpen(true);
                }}
              >
                Property Details <Image src="/images/more-info.svg" />
              </span>
            )}
          </div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Address">
            <Image src="/images/address.svg" />
          </span>
          <div className="chat-value">{reservation?.pms_address}</div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Reservation Number">
            <Image src="/images/reservation-number.svg" />
          </span>
          <div className="chat-value">
            <ReservationNumber
              hostID={reservation?.host_id}
              pms={user?.details?.pms}
              resevationID={reservation?.reservation_id}
              nativeID={reservation?.native_id}
            />
          </div>
        </div>

        {reservation?.door_code && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Door Code">
              <Image src="/images/door-code.svg" />
            </span>
            <div className="chat-value">{reservation?.door_code}</div>
          </div>
        )}

        {reservation?.source && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Booking Source">
              <Image src="/images/booking-source.svg" />
            </span>
            <div className="chat-value">{reservation?.source}</div>
          </div>
        )}

        {reservation?.guest_reservation_id && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Guest Book">
              <Image src="/images/messages-guestbook.svg" />
            </span>
            <div className="chat-value">
              <a
                href={`${host}/v2/reservations/guestbook/${reservation.guest_reservation_id}`}
                target="_blank"
                rel="noreferrer"
              >
                Guestbook
              </a>
            </div>
          </div>
        )}
        
        {(user?.details?.pms === "Streamline" ||
          user?.details?.pms === "LiveRez" ||
          user?.details?.pms === "Hostaway") && (
          <div className="uk-margin-small message-text-group">
            <span
              uk-tooltip={
                reservation?.contract_signed
                  ? "Contract Signed"
                  : "Contract Not Signed"
              }
            >
              <Image
                src={
                  reservation?.contract_signed
                    ? "/images/messages-contract-signed.svg"
                    : "/images/messages-contract-not-signed.svg"
                }
              />
            </span>

            <div className="chat-value">
              {reservation?.contract_signed
                ? "Contract Signed"
                : <span style={{ color: "var(--red)" }}>Contract Not Signed</span>}
            </div>
          </div>
        )}

        {(user?.details?.pms === "Streamline" || user?.details?.pms === "LiveRez") &&
          !String(reservation?.source || "").toLowerCase().includes("airbnb") &&
          !String(reservation?.source || "").toLowerCase().includes("vrbo") &&
          !String(reservation?.source || "").toLowerCase().includes("booking.com") &&
          rentTotal > 0 && (
            <div className="uk-margin-small message-text-group">
              <span uk-tooltip={rentOwed > 0 ? "Rent Owed" : "Paid in Full"}>
                <Image
                  src={
                    rentOwed > 0
                      ? "/images/messages-balance-pending.svg"
                      : "/images/messages-balance.svg"
                  }
                />
              </span>

              <div className="chat-value">
                {rentOwed > 0
                  ? <span style={{ color: "var(--red)" }}>{`Rent Owed: $${formatMoney(rentOwed)}`}</span>
                  : `Rent Total: $${formatMoney(rentTotal)}`}
              </div>
            </div>
          )}

      </div>
    );
  };

  const getTabsAndContents = () => {
    const tabList = [];
    const contentList = [];

    if (sortedReservations.current.length !== 0) {
      tabList.push(
        <li key="current">
          <a href="#">Current ({sortedReservations.current.length})</a>
        </li>,
      );
      contentList.push(
        <li key="current-content">{reservationRenderer("current")}</li>,
      );
    }
    if (sortedReservations.upcoming.length !== 0) {
      tabList.push(
        <li key="upcoming">
          <a href="#">Upcoming ({sortedReservations.upcoming.length})</a>
        </li>,
      );
      contentList.push(
        <li key="upcoming-content">{reservationRenderer("upcoming")}</li>,
      );
    }

    if (sortedReservations.past.length !== 0) {
      tabList.push(
        <li key="past">
          <a href="#">Past ({sortedReservations.past.length})</a>
        </li>,
      );
      contentList.push(
        <li key="past-content">{reservationRenderer("past")}</li>,
      );
    }

    return { tabList, contentList };
  };

  const { tabList, contentList } = getTabsAndContents();

  useEffect(() => {
    UIkit.tab(".uk-tab", { connect: ".uk-switcher" });
  }, [tabList.length, contentList.length]);

  const [contactProperties, setContactProperties] = useState([]);

  useEffect(() => {
    setContactProperties([]);
    const id = contact?.id || threadInfo?.id;
    if (!id) return;

    if (Array.isArray(contact?.rentals) && contact.rentals.length) {
      setContactProperties(contact.rentals);
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${host}/v2/contacts/${id}?include=rentals`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Failed to load contact w/ rentals");
        const data = await res.json();

        const rentals = (data?.rentals ?? []).map((r) => ({
          rental_id: r.rental_id ?? r.id ?? r.rentalId,
          pms_id: r.pms_id ?? r.pmsId ?? r.code ?? r.pms_code,
        }));

        setContactProperties(
          rentals
            .filter((r) => r.rental_id || r.pms_id)
            .sort((a, b) => String(a.pms_id || "").localeCompare(String(b.pms_id || "")))
        );
      } catch (e) {
        console.warn("contact rentals fetch failed:", e);
        setContactProperties([]);
      }
    })();
  }, [contact?.id, contact?.rentals, threadInfo?.id, host]);

  return (
    <div className="uk-card uk-card-default uk-card-small uk-card-body hms-msg-cards hms-booking-info">
      <div className="message-text-group guest-info" uk-grid>
        <span
          className="message-text-group-icon"
          uk-tooltip={`title: ${threadInfo.category?.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"}; pos: bottom-left; cls: uk-active contact-tooltip`}
        >
          <Image src={`/images/${threadInfo.category || "guest"}-active.svg`} />
        </span>
        <div className="uk-width-expand">
          <div className="guest-chat-info">
            <div className="chat-guest-value semi-bold-font">
              {threadInfo.first_name} {threadInfo.last_name}
            </div>
            <div className="chat-guest-value">{threadInfo.formatted_phone}</div>
            <div className="chat-guest-value">{threadInfo.email}</div>

            {!threadInfo.category && (
              <div className="chat-guest-value">
                {guest_reservations.length} booking(s)
              </div>
            )}
          </div>
        </div>
      </div>

      {contactProperties.length > 0 && (
        <div className="uk-flex uk-flex-top uk-margin-top">
          <img
            src="/images/rental.svg"
            alt="Properties"
          />

          <div className="hms-guest-tags">
            <div className="guest-tags uk-flex uk-flex-wrap">
              {contactProperties.map((p) => (
                <div
                  className="uk-inline"
                  key={String(p.rental_id ?? p.pms_id)}
                >
                  {p.pms_id || `#${p.rental_id}`}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {!threadInfo.category && (
        <div>
          <ul
            className="uk-tab uk-margin-small-top bookings"
            uk-tab="connect: #reservation-switcher"
          >
            {tabList}
          </ul>
          <ul
            id="reservation-switcher"
            className="uk-switcher uk-margin-small-top"
          >
            {contentList}
          </ul>
        </div>
      )}
      <PropertyDetailsModal
        open={propertyDetailsOpen}
        rentalId={currentReservation?.rental_id}
        onClose={() => setPropertyDetailsOpen(false)}
      />
    </div>
  );
};

export default GuestDetails;
